import React from 'react'
import classNames from 'classnames'

import { ImgSanity } from '@slite/components'

import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'

export const Section3CardsBenefits = ({
  title,
  subtitle,
  background = 'shade-100',
  benefits,
}: {
  title: React.ReactNode
  subtitle?: React.ReactNode
  background?: string
  benefits: {
    imageUrl: string
    imageBackground: string
    imageAlt: string
    title: string
    description: string
  }[]
}) => {
  return (
    <Section background={background} containerTopPadding={0}>
      <div className="grid-12">
        <div className="grid-span-10 grid-offset-1 text-align-center margin-bottom-32">
          <WebsiteText variant="title" className="margin-bottom-40">
            {title}
          </WebsiteText>
          {subtitle && <div className="margin-bottom-32">{subtitle}</div>}
        </div>
      </div>

      <div className="grid-12 grid-column-gap-32 grid-row-gap-40">
        {benefits.map((ben) => (
          <div
            key={ben.title}
            className={classNames(
              'grid-span-4 grid-span-6-medium',
              ' grid-span-10-small grid-offset-1-small'
            )}
          >
            <div
              className={classNames(
                'radius-larger margin-bottom-20 flexbox flexbox-centered',
                `background-${ben.imageBackground}`
              )}
              style={{ aspectRatio: '1/1' }}
            >
              <ImgSanity src={ben.imageUrl} alt={ben.imageAlt} />
            </div>
            <h3 className="font-family-title font-weight-medium margin-bottom-8">
              {ben.title}
            </h3>
            <WebsiteText variant="body-lg">{ben.description}</WebsiteText>
          </div>
        ))}
      </div>
    </Section>
  )
}
